<template>
	<!-- 首页 -->
	<div>
		<!-- top -->
		<headers/>
		<!-- 内容 -->
		<div class="common">
			<div class="banner">
				<img src="../../assets/images/banner.jpg" alt="" class="bannerImg">
				<div class="bannerCont">
					<img src="../../assets/images/logos.png" alt="" class="logo">
					<p class="p1">山东智能好停车服务有限公司</p>
					<p class="p2">全国领先的城市级智慧停车技术服务与运营商</p>
				</div>
			</div>
			<!-- 一站式解决问题 -->
			<div class="quest">
				<div class="questItem">
					<div class="title">
						<div class="back">一站式解决方案</div>
						<p class="english">Desig service</p>
					</div>
					<div class="item">
						<div class="itemList">
							<img src="../../assets/icon/icon_1.png" alt="" class="icon">
							<p class="font">停车设备</p>
							<div class="equipment">
								<div v-for="(item,index) in equipment" :key="index" class="equipmentList">
									<img :src="item.image" alt="" class="equipImg">
									<p>{{item.name}}</p>
								</div>
							</div>
						</div>
						<div class="itemList">
							<img src="../../assets/icon/icon_2.png" alt="" class="icon">
							<p class="font">运营管理后台</p>
							<div class="equipment">
								<div v-for="(item,index) in equipment" :key="index" class="equipmentList">
									<img :src="item.adminImg" alt="" class="equipImg">
									<p>{{item.admin}}</p>
								</div>
							</div>
						</div>
						<div class="itemList">
							<img src="../../assets/icon/icon_3.png" alt="" class="icon">
							<p class="font"> 软件定制开发</p>
							<div class="equipment">
								<div v-for="(item,index) in equipment" :key="index" class="equipmentList">
									<img :src="item.customizedImg" alt="" class="equipImg">
									<p>{{item.customized}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 案例展示 -->
			<div class="rno-client-case-inner">
				<div class="rno-client-case-section-bg" style="background-image: url(https://main.qcloudimg.com/raw/c67915de77221e682f37b1da31d6a0e8.jpg)"></div>
				<div class="rno-client-case-main">
					<div class="rno-client-case-box">
						<div class="rno-client-case-title">客户案例</div>
						<div class="rno-client-case-cont">
							<div class="rno-client-case-desc rno-line-clamp-3">打造以无感停车体验为核心的智慧停车管理平台。综合利用物联网、大数据、云计算、电子支付等技术，覆盖路内停车、路外停车等多种停车场景。</div>
						</div>
					</div>
					<!-- 展示位置 -->
					<div class="rno-client-case-slide ">
						<div class="back_add">
							<div class="threeImg">
								<div class="Containt">
									<ul :style="{'left':calleft + 'px'}"  v-on:mouseover="stopmove()" v-on:mouseout="move()">
										<li v-for="(item,indexs) in superurl" :key="indexs">
											<img :src="item"/>
										</li>
									</ul>
								</div>
								<div class="iconleft"  @click="zuohua">
									<i class="el-icon-arrow-left"></i>
								</div>
								<div class="iconright" @click="youhua">
									<i class="el-icon-arrow-right" ></i>
								</div>
							</div>
						   
						</div>

					</div>
				</div>
				<i class="rno-client-case-dot"></i>
				<i class="rno-client-case-decorate"></i>
			</div>
			<!-- 硬件设备 -->
			<div class="quest" style="height:700px;">
				<div class="questItem">
					<div class="title">
						<div class="back">硬件设备</div>
						<p class="english">Hardware equipment</p>
					</div>
					<!-- 设备列表 -->
					<div class="deviceList">
						<swiperHome/>
					</div>
				</div>
			</div>
			<!-- 我们的优势 -->
			<div class="banner" style="position: relative;height: 730px;">
				<div class="advantage">
					<img src="../../assets/images/back2.png" alt="" class="advantageimg">
				</div>
				<div class="questItem questPosition">
					<div class="title">
						<div class="back">核心优势</div>
						<p class="english">CORE ADVANTAGES</p>
					</div>
					<div class="advantageList">
						<div class="item">
							<div class="itemImg">
								<img src="../../assets/images/made.png" alt="" class="itemImgs">
							</div>
							<div class="made">
								<p class="p1">高度定制</p>
								<p class="p2">多年主流行业的深度研究与服务经验，你想要的定制我们都可以提供;</p>
							</div>
						</div>
						<div class="item">
							<div class="itemImg">
								<img src="../../assets/images/case.png" alt="" class="itemImgs">
							</div>
							<div class="made">
								<p class="p1">丰富的案例</p>
								<p class="p2">100+真实案例积累支撑，成熟的解决方案，品质有保障;</p>
							</div>
						</div>
						<div class="item">
							<div class="itemImg">
								<img src="../../assets/images/help.png" alt="" class="itemImgs">
							</div>
							<div class="made">
								<p class="p1">专业研发团队护航</p>
								<p class="p2">平均5+以上的开发经验，曾经均就职大型互联网公司;</p>
							</div>
						</div>
						<div class="item">
							<div class="itemImg">
								<img src="../../assets/images/memeber.png" alt="" class="itemImgs">
							</div>
							<div class="made">
								<p class="p1">会员跟踪服务</p>
								<p class="p2">和我们合作的客户，定期回访产品使用情况，我们用心服务好每一个客户;</p>
							</div>
						</div>
						<div class="item">
							<div class="itemImg">
								<img src="../../assets/images/start.png" alt="" class="itemImgs">
							</div>
							<div class="made">
								<p class="p1">一流的品质把控</p>
								<p class="p2">一对一的客服需求对接，及时充分了解客户需求，并具备专业的商业思维分析及成熟的技术支持;</p>
							</div>
						</div>
						<div class="item">
							<div class="itemImg">
								<img src="../../assets/images/serive.png" alt="" class="itemImgs">
							</div>
							<div class="made">
								<p class="p1">更多服务</p>
								<p class="p2">运营培训，线上维护，软著申请、渠道发布等，还能提供更多售后服务。</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 定制方案 -->
			<div class="quest caseMade">
				<div class="questItem">
					<div class="title">
						<div class="back">定制方案流程</div>
						<p class="english">CUSTOM SERVICE PROCESS</p>
					</div>
					<img src="../../assets/images/process.png" alt="" class="process" style="margin-top: 20px;">
				</div>
			</div>
			<!-- 咨询 -->
			<div class="consult">
				<div class="consultItem">
					<h1>咨询行业专业顾问</h1>
					<p>关于好停车解决方案的更多咨询，以及解决方案个性化的定制需求，请联系我们的销售和技术支持团队。同时我们也为您提供个性化的售前购买咨询服务，以及全面的技术售后服务。</p>
					<a href="" class="btn">立即咨询</a>
				</div>
				
			</div>
		</div>
		<!-- bottom -->
		<footers/>
		
	</div>
</template>

<script>
	import headers from '@/components/header.vue'
	import footers from '@/components/footer.vue'
	import swiperHome from '@/components/swiperHome.vue'
	import features1 from '@/assets/images/equipment/features_1.png'
	import features2 from '@/assets/images/equipment/features_2.png'
	import features3 from '@/assets/images/equipment/features_3.png'
	import features4 from '@/assets/images/equipment/features_4.png'
	import features5 from '@/assets/images/equipment/features_5.png'
	import features6 from '@/assets/images/equipment/features_6.png'
	import adminImg1 from '@/assets/images/equipment/adminImg-1.png'
	import adminImg2 from '@/assets/images/equipment/adminImg-2.png'
	import adminImg3 from '@/assets/images/equipment/adminImg-3.png'
	import adminImg4 from '@/assets/images/equipment/adminImg-4.png'
	import adminImg5 from '@/assets/images/equipment/adminImg-5.png'
	import adminImg6 from '@/assets/images/equipment/adminImg-6.png'
	import customized1 from '@/assets/images/equipment/customized-1.png'
	import customized2 from '@/assets/images/equipment/customized-2.png'
	import customized3 from '@/assets/images/equipment/customized-3.png'
	import customized4 from '@/assets/images/equipment/customized-4.png'
	import customized5 from '@/assets/images/equipment/customized-5.png'
	import customized6 from '@/assets/images/equipment/customized-6.png'
	import pictureA from '@/assets/images/home/pictureA.jpg'
	import pictureB from '@/assets/images/home/pictureB.jpg'
	import pictureC from '@/assets/images/home/pictureC.jpg'
	import pictureD from '@/assets/images/home/pictureD.jpg'
	import pictureE from '@/assets/images/home/pictureE.jpg'
	import pictureF from '@/assets/images/home/pictureF.jpg'
	export default {
		components:{
			headers,footers,swiperHome
		},
		data(){
			return{
				equipment:[{
					name:'智能道闸',
					admin:'用户管理',
					customized:'网站',
					image:features1,
					adminImg:adminImg1,
					customizedImg:customized1
				},{
					name:'车辆识别设备',
					admin:'泊位管理',
					customized:'APP',
					image:features2,
					adminImg:adminImg2,
					customizedImg:customized2
				},
				{
					name:'显示屏',
					admin:'资源监控',
					customized:'微信小程序',
					image:features3,
					adminImg:adminImg3,
					customizedImg:customized3
				},
				{
					name:'车位检测器',
					admin:'订单管理',
					customized:'嵌入式开发',
					image:features4,
					adminImg:adminImg4,
					customizedImg:customized4
				},
				{
					name:'车位锁',
					admin:'数据分析',
					customized:'第三方支付',
					image:features5,
					adminImg:adminImg5,
					customizedImg:customized5
				},
				{
					name:'PDA设备',
					admin:'系统设置',
					customized:'其他出行服务',
					image:features6,
					adminImg:adminImg6,
					customizedImg:customized6
				}],
				superurl: [pictureA,pictureB,pictureC,pictureD,pictureE,pictureF],
				calleft:0
			}
		},
		created() {
			// this.move();
		},
		methods:{
			//移动
			move() {
				this.timer = setInterval(this.starmove, 2500)
			},
			//开始移动
			starmove() {
				this.calleft -= 340;
				if (this.calleft < -1200) {
					this.calleft = 0
				}
			},
			//鼠标悬停时停止移动
			stopmove() {
				clearInterval(this.timer)
			},
			//点击按钮左移
			zuohua() {
				console.log(123);
				this.calleft -= 340;
				if (this.calleft < -1200) {
					this.calleft = 0
				}
			},
			//点击按钮右移
			youhua() {
				this.calleft += 340;
				if (this.calleft > 0) {
					this.calleft = -1020
				}
			},
		}
	}
</script>

<style lang='scss' scoped>
	.banner{
		width: 100%;
		height: 600px;
		margin: 0 auto;
		vertical-align: middle;
		position: relative;
		text-align: center;
		.bannerImg{
			width: 100%;
			height: 100%;
			object-fit: cover;
			
		}
		.bannerCont{
			width: 1200px;
			position: absolute;
			height: 600px;
			left: 50%;
			top: 50%;
			margin-left:-600px;
			margin-top: -300px;
			color: #fff;
			text-align: center;
			.logo{
				margin-top: 100px;
			}
			.p1{
				font-size: 30px;
				padding: 10px;
			}
			.p2{
				font-size:32px;
				padding: 10px;
				font-weight: bold;
			}
		}
	}
	.quest{
		width: 100%;
		height: 700px;
		background: url(../../assets/images/back.png) center bottom no-repeat;
		background-size: 100% 40%;
		color:#333;
		.questItem{
			width: 1200px;
			height: 100%;
			margin: 0 auto;
			background:transparent;
			.title{
				text-align:center;
				margin-top:50px;
				.back{
					font-size:34px ;
					color: #3c77f0;
					height: 70px;
					background: url(../../assets/images/line.png) center bottom no-repeat;
				}
				.english{
					margin-top: 10px;
					text-transform: uppercase;
					color: #666;
					font-size: 18px;
					letter-spacing: 5px;
				}
			}
			.item{
				display: flex;
				flex-direction: row;
				margin-top:70px;
				text-align:center;
				.itemList{
					width:370px ;
					height:450px ;
					background: #fff;
					border-radius: 20px;
					border: 1px solid #fbfbfb;
					box-shadow: 0px 0px 12px rgba(102,102,102,0.3);
					margin-right: 45px;
					&:last-children{
						margin-right: 0;
					}
					.icon{
						margin: 30px 0;
					}
					.font{
						font-size: 28px;
					}
					.equipment{
						display: flex;
						flex-direction: row;
						vertical-align: middle;
						flex-flow: wrap;
						margin-top:30px;
						.equipmentList{
							width: 30%;
							margin-right: 5%;
							margin-bottom:5px;
							&:nth-child(3n){
								margin-right: 0;
							}
							.equipImg{
								width: 40px;
								height: 40px;
							}
						}
					}
				}
				
			}
		}
	}
	.rno-client-case-inner{
		background-color: #1C2437;
		position: relative;
		font-size: 0;
		padding: 0 0 0 42%;
		overflow: hidden;
		height:500px;
		.rno-client-case-section-bg {
		    background-size: cover;
		    height: 100%;
		    width: 42%;
		    position: absolute;
		    left: 0;
		    top: 0;
		}
		.rno-client-case-main {
		    display: inline-block;
		    vertical-align: top;
		    width: 58%;
		}
		.rno-client-case-dot {
		    position: absolute;
		    right: 264px;
		    top: 227px;
		    width: 144px;
		    height: 60px;
			background-image:url(../../assets/images/solution-202101151848.svg);
		    background-size: 206.94444444444446% 426.6666666666667%;
		    background-position: 0.65% 90.31%;
		    background-repeat: no-repeat;
		}
		.rno-client-case-decorate {
		    position: absolute;
		    right: 0;
		    top: 0;
		    width: 296px;
		    height: 174px;
		    background-image:url(../../assets/images/solution-202101151848.svg);
		    background-size: 100.67567567567568% 147.1264367816092%;
		    background-position: 50% 1.22%;
		    background-repeat: no-repeat;
		}
		.rno-client-case-box {
		    padding: 60px 0 0 60px;
		    max-width: 740px;
		    position: relative;
		    z-index: 5;
		}
		.rno-client-case-title {
		    font-size: 32px;
		    color: #FFF;
		    line-height: 48px;
		    white-space: nowrap;
		    overflow: hidden;
		    text-overflow: ellipsis;
		}
		.rno-client-case-cont {
		    height: 80px;
		}
		.rno-client-case-desc {
		    opacity: .6;
		    font-size: 14px;
		    color: #FFF;
		    line-height: 24px;
		    margin-top: 12px;
		}
		.rno-line-clamp-3 {
		    -webkit-line-clamp: 3;
		    max-height: 72px;
		}
		.rno-client-case-slide{
			.back_add {
				width: 1000px;
				position: absolute;
				bottom: 90px;
				z-index: 3;
				margin-left: -150px;
			}
			.threeImg {
			    height: 180px;
			    min-width: 1000px;
			}
			.threeImg .Containt ul {
			    margin: 0 auto;
			    width: 2400px;
			    position: absolute;
			    left: 0px;
			    cursor: pointer;
			    height: 100%
			}
			 
			.threeImg .Containt ul li {
			    width: 320px;
			    margin-right: 20px;
			    margin-top: 10px;
			    float: left;
				background: #fff;
				height: 180px;
			}
			 
			.threeImg .Containt ul li img {
			   height: 180px;
			    width: 100%;
			}
			.Containt {
			    position: relative;
			    width: 1000px;
			    height: 180px;
			    overflow: hidden;
			    margin: 0 auto;
			}
			 
			.iconleft {
			    position: absolute;
			    width: 24px;
			    height: 24px;
			    top: 190px;
			    z-index: 99999;
			    vertical-align: middle;
				background-image:url(../../assets/images/solution-202101151848.svg);
				background-position: 63.13999999999999% 76.29%;
				background-size: 1241.6666666666665% 1066.6666666666665%;
				background-repeat: no-repeat;
				cursor: pointer;
			}
			 
			.iconright {
				position: absolute;
				left: 40px;
			    width: 24px;
			    height: 24px;
			    top: 190px;
			    z-index: 99999;
			    vertical-align: middle;
			    background-image:url(../../assets/images/solution-202101151848.svg);
			    background-position: 91.61% 76.29%;
			    background-size: 1241.6666666666665% 1066.6666666666665%;
			    background-repeat: no-repeat;
				cursor: pointer;
			}
		}
	}
	
	.advantage{
		height: 730px;
		width: 100%;
		.advantageimg{
			width: 100%;
			height: 100%;
		}
		
	}
	.questPosition{
		position: absolute;
		width: 1200px;
		height: 100%;
		top:50%;
		left:50%;
		margin-left:-600px;
		margin-top:-300px;
		z-index:111;
		.title{
			text-align:center;
			padding-top:70px;
			.back{
				font-size:34px ;
				color: #fff;
				height: 70px;
				background: url(../../assets/images/line2.png) center bottom no-repeat;
			}
			.english{
				margin-top: 10px;
				text-transform: uppercase;
				color: #fff;
				font-size: 18px;
				letter-spacing: 5px;
			}
		}
		.advantageList{
			display: flex;
			flex-direction: row;
			vertical-align: middle;
			flex-flow: wrap;
			margin-top:70px;
			.item{
				width: 30%;
				margin-right: 5%;
				height:140px;
				margin-bottom: 80px;
				flex-direction: row;
				display: flex;
				&:nth-child(3n){
					margin-right: 0;
				}
				.itemImg{
					width: 50px;
					height: 50px;
					margin-right: 30px;
					.itemImgs{
						width: 100%;
					}
				}
				.made{
					width: 80%;
					text-align:left;
					.p1{
						font-size: 28px;
						color: #fff;
					}
					.p2{
						padding-top: 20px;
						color: #fff;
						font-size: 16px;
						line-height: 2;
					}
				}
			}
		}
	}
	.caseMade{
		height:600px ;
		background: #f5f7fa;
		margin-top:0px;
		.questItem {
			.title{
				padding-top: 50px;
				margin-top: 0;
			}
		}
	}
	.consult{
		width: 100%;
		height: 340px;
		margin: 0 auto;
		text-align: left;
		background: url(../../assets/images/bottomBack.png) center bottom no-repeat;
		background-size:100% 100%;
		.consultItem{
			width:1200px;
			margin:0 auto;
			h1{
				font-size: 26px;
				color: #fff;
				padding-top: 100px;
			}
			p{
				font-size: 14px;
				color: #fff;
				width:800px;
				margin-top: 20px;
				line-height: 2;
			}
			a{
				display: inline-block;
				padding: 5px 10px;
				font-size: 14px;
				color: #fff;
				margin-top: 20px;
				border-radius: 5px;
				background: #3c77f0;
			}
		}
		
	}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue